// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeMicroLab = {
  microLabPlatformDataContractInvalid: "Micro Lab 平台数据合同无效：{field_name}，{reason}",
} as const;
